<template>
  <div class="rich-content">
    <template v-for="(section, index) in sections" :key="index">
      <h2 v-if="section.type === 'heading' && section.level === 2">{{ section.text }}</h2>
      <h3 v-else-if="section.type === 'heading' && section.level === 3">{{ section.text }}</h3>
      <h4 v-else-if="section.type === 'heading' && section.level === 4">{{ section.text }}</h4>

      <p v-else-if="section.type === 'paragraph'">{{ section.text }}</p>

      <figure v-else-if="section.type === 'image'" class="rich-figure">
        <img :src="section.src" :alt="section.alt || ''" />
        <figcaption v-if="section.caption">{{ section.caption }}</figcaption>
      </figure>
    </template>
  </div>
</template>

<script>
export default {
  name: 'RichContentRenderer',
  props: {
    sections: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.rich-content {
  display: grid;
  gap: 0.95rem;
}

.rich-content h2,
.rich-content h3,
.rich-content h4 {
  margin: 1.2rem 0 0.2rem;
}

.rich-content h2 {
  font-size: clamp(1.35rem, 2.2vw, 1.7rem);
}

.rich-content h3 {
  font-size: clamp(1.2rem, 2vw, 1.45rem);
}

.rich-content h4 {
  font-size: clamp(1.08rem, 1.8vw, 1.25rem);
}

.rich-content p {
  color: var(--white);
  max-width: 70ch;
}

.rich-figure {
  margin: 0.35rem 0;
}

.rich-figure img {
  width: 100%;
  border-radius: var(--radius);
  border: 1px solid var(--line);
  display: block;
}

.rich-figure figcaption {
  margin-top: 0.45rem;
  color: var(--orange);
  font-size: 0.92rem;
}
</style>
